const defaultState = {
  isLoaded: true,
  isLoadedSubjects: false,
  folders: [],
  subfolders: [],
  selectFolders: null,
  selectSubfolder: null,
  list: [],
  isShowModal: false,
  isTrashed: false,
  item: {},
  slider: {},
  slide: {},
  sliders: [],
  checkFolders: [],
  checkSubcategories: [],
  checkCategories: [],
  checkSubfolders: [],
  sessions: []
}

const slider = (state = defaultState, action) => {
  switch (action.type) {
    case 'CREATE_SLIDER':
      return {
        ...state,
        list: [...state.list, action.data],
        isLoaded: true
      }
    case 'UPDATE_SLIDER':
      return {
        ...state,
        list:  state.list.map(_i => _i.id == action.data.id ? {...action.data} : {..._i}),
        isLoaded: true
      }
    case 'DELETE_SLIDER':
      return {
        ...state,
        list: state.list.filter(_i => _i.id != action.data),
        isLoaded: true
      }
    case 'SET_SLIDER':
      return {
        ...state,
        slider: action.slider,
        sliders: action.sliders,
        isLoaded: true
      };
    case 'ADD_SLIDER_SLIDER':
      return {
        ...state,
        sliders: [...state.sliders, action.data],
      };
    case 'SET_SLIDERS':
      return {
        ...state,
        list: action.data,
        isLoaded: true
      };
    case 'SET_SLIDERS_FOLDER_UPDATE':
      return {
        ...state,
        folders: !action.data.parent_id ? state.folders.map(_i => _i.id == action.data.id ? {...action.data} : {..._i}, ) : state.folders,
        subfolders: action.data.parent_id ? state.subfolders.map(_i => _i.id == action.data.id ? {...action.data} : {..._i}, ) : state.subfolders,
        isLoaded: true
      };
    case 'SET_SLIDERS_FOLDER_ADD':
      return {
        ...state,
        folders: !action.data.parent_id ? [...state.folders, action.data] : state.folders,
        subfolders: action.data.parent_id ? [...state.subfolders, action.data] : state.subfolders,
        isLoaded: true
      };
    case 'SET_SLIDERS_FOLDER_DELETE':
      return {
        ...state,
        folders: state.folders.filter(_i => _i.id != action.data),
        selectFolders: null,
        list: state.list.filter(_i => _i.folder_id != action.data),
        checkFolders: state.checkFolders.filter(_i => _i != action.data),
        isLoaded: true
      };
    case 'SET_SLIDERS_SUBFOLDER_DELETE':
      return {
        ...state,
        subfolders: state.subfolders.filter(_i => _i.id != action.data),
        list: state.list.filter(_i => _i.subfolder_id != action.data),
        checkSubfolders: state.checkSubfolders.filter(_i => _i != action.data),
        selectSubfolder: null,
        isLoaded: true
      };
    case 'SET_SLIDERS_FOLDERS':
      return {
        ...state,
        folders: action.data,
        subfolders: action.subfolders,
        isLoadedFolders: true,
        isLoaded: true
      };
    case 'DELETE_SLIDER_ITEMS':
      return {
        ...state,
        sliders: state.sliders.filter(_i => !action.data.includes(_i.id)),
        slide: action.data.includes(state.slide?.id) ? {} : state.slide,
        isLoaded: true,
      };
    case 'SET_SLIDERS_KEY':
      return {
        ...state,
        [action.key]: action.data,
      };
    default:
      return state
  }
}

export default slider;
